module.exports = __webpack_public_path__ + "img/Grundriss EG.b3593850.jpg";